import { render, staticRenderFns } from "./ModalTermAndCondition.vue?vue&type=template&id=0d82f48d&scoped=true&"
import script from "./ModalTermAndCondition.vue?vue&type=script&lang=js&"
export * from "./ModalTermAndCondition.vue?vue&type=script&lang=js&"
import style0 from "./ModalTermAndCondition.vue?vue&type=style&index=0&id=0d82f48d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d82f48d",
  null
  
)

export default component.exports